var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2214_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44011 9.66913C7.55652 9.80903 7.75169 10.0157 7.75169 10.0157C7.75169 10.0157 7.42736 10.1067 7.22152 10.1711C7.01513 10.2355 6.6963 10.3455 6.6963 10.3455C6.6963 10.3455 6.83975 10.034 6.93355 9.81008C7.01937 9.60517 7.14284 9.28111 7.14284 9.28111C7.14284 9.28111 7.31803 9.52239 7.44011 9.66913Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86103 0.446289H2.9043C2.18164 0.446289 1.27588 1.03915 1.27588 2.16024V14.1446C1.27588 15.2267 2.13477 15.8634 2.93945 15.8634H12.6778L10.819 13.4414L11.8843 13.4415V10.7719H13.3876V4.9818L8.86103 0.446289ZM8.77075 5.06532V1.42319L12.4082 5.06532H8.77075ZM4.13276 12.5933C3.89122 12.3723 3.85983 12.0049 4.16684 11.689C4.37212 11.4778 4.62698 11.3089 4.91371 11.1386C5.20827 10.9637 5.4982 10.8342 5.72749 10.7317L5.74199 10.7252C5.74199 10.7252 6.09322 10.064 6.2758 9.62951C6.4523 9.20956 6.68252 8.53874 6.68252 8.53874C6.48588 8.17027 6.24834 7.64052 6.1995 7.1145C6.16193 6.70982 6.28246 6.19236 6.86105 6.13935C7.25202 6.10353 7.56709 6.34139 7.63266 6.8421C7.6604 7.0539 7.66846 7.59923 7.41479 8.44953C7.67141 8.88918 8.09717 9.46169 8.53892 9.82789C9.07933 9.71931 9.49679 9.66296 9.97986 9.70182C10.3607 9.73246 10.7669 9.9691 10.7669 10.3776C10.7669 10.7122 10.6093 11.1061 9.78743 11.0833C9.20477 11.0672 8.7789 10.8449 8.37823 10.5618C8.37823 10.5618 7.72164 10.7323 7.31075 10.8643C6.87413 11.0045 6.2135 11.2628 6.2135 11.2628L6.18021 11.3193C6.01486 11.6006 5.70368 12.13 5.24771 12.513C4.86587 12.8337 4.44129 12.8755 4.13276 12.5933Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8274 10.4842H13.6535V13.4538H14.7241L12.7668 15.8008L10.7676 13.4538H11.8274V10.4842Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2214_2215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download-pdf.3dce7c7aaae8825148f8932ec898ca5e.svg";
export { ForwardRef as ReactComponent };